import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import Lenis from "lenis";
import Landing from "@/pages/Landing";
import FunctionalMedicine from "@/pages/FunctionalMedicine";
import Privacy from "@/pages/Privacy";
import RegistrationPreview from "@/pages/RegistrationPreview";
import DepositConfirmed from "@/pages/DepositConfirmed";
import OfficeDashboard from "@/pages/OfficeDashboard";
import { pushMarketingEvent } from "@/lib/track";

function App() {
  useEffect(() => {
    const onClick = (e) => {
      const a = e.target.closest?.('a[href^="tel:"]');
      if (a) {
        pushMarketingEvent("call_click", {
          link_location: a.getAttribute("data-call-location") || "page",
        });
      }
    };
    document.addEventListener("click", onClick, true);
    return () => document.removeEventListener("click", onClick, true);
  }, []);

  useEffect(() => {
    const lenis = new Lenis();
    let rafId;
    const raf = (time) => {
      lenis.raf(time);
      rafId = requestAnimationFrame(raf);
    };
    rafId = requestAnimationFrame(raf);
    return () => {
      cancelAnimationFrame(rafId);
      lenis.destroy();
    };
  }, []);

  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Navigate to="/menopause" replace />} />
        <Route path="/menopause" element={<Landing variant="menopause" />} />
        <Route path="/menopause-call" element={<Landing variant="menopause-call" />} />
        <Route path="/functional-medicine" element={<FunctionalMedicine />} />
        <Route path="/office" element={<OfficeDashboard />} />
        <Route path="/privacy" element={<Privacy />} />
        <Route path="/deposit-confirmed" element={<DepositConfirmed />} />
        <Route path="/preview/registration" element={<RegistrationPreview />} />
        <Route path="*" element={<Navigate to="/menopause" replace />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
